import {Component, Input, OnInit} from '@angular/core';
import { CmsLinkComponentGeneric } from '../cms-link';
import {AuthService, FeaturesService, AccessibilityService} from '@signature-it/ngx-generic/services';
import { InteractivityChecker } from "@angular/cdk/a11y";

@Component({
    selector: 'cms-link-b-custom',
    templateUrl: '../cms-link.html',
    styleUrls: ['../cms-link.scss'],
    standalone: false
})
export class CmsLinkBComponentGeneric extends CmsLinkComponentGeneric implements OnInit{
    @Input() dataHref;
    @Input() dataText;
    @Input() dataClasses;
    @Input() dataIsLoginLink;
    @Input() dataDependApi;

    constructor(protected authService: AuthService,
                protected featuresSvc: FeaturesService,
                protected a11ySvc: AccessibilityService,
                protected interactivityChecker: InteractivityChecker) {
        super( authService, featuresSvc, a11ySvc, interactivityChecker);
    }

    ngOnInit() {
        super.ngOnInit();
    }
}
